export default function BankAccountForm({ form, setForm, onSubmit }) {
  return (
    <form onSubmit={onSubmit}>
      <div className="mb-2">
        <label>Nama Bank</label>
        <input className="form-control" value={form.bank_name} onChange={(e) => setForm({ ...form, bank_name: e.target.value })} required />
      </div>
      <div className="mb-2">
        <label>Nama Pemilik</label>
        <input className="form-control" value={form.account_name} onChange={(e) => setForm({ ...form, account_name: e.target.value })} required />
      </div>
      <div className="mb-2">
        <label>Nomor Rekening</label>
        <input className="form-control" value={form.account_number} onChange={(e) => setForm({ ...form, account_number: e.target.value })} required />
      </div>
      <button className="btn btn-primary">Simpan</button>
    </form>
  );
}
